<template>
  <div class="financingSources">
    <div class="level table-actions">
      <div class="level-left">
        <form @submit.prevent="onSearch">
          <div class="field is-grouped controls">
            <div class="control">
              <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
            </div>
            <div class="control">
              <button type="submit" class="button is-primary">
                <b-icon icon="magnify" size="is-small"></b-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="level-right">
        <div class="field is-grouped controls">
          <div class="control">
            <button @click="goTo('createFinancingSource')"
                    class="button is-success">
              {{ $t('financingSources.create') }}
            </button>
          </div>
          <div class="control">
            <button @click="removeSelected"
                    :disabled="checkedRows.length === 0"
                    class="button is-danger">
              {{ $t('interface.removeSelected') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table class="mt-10"
             :data="list"
             :loading="loading"

             paginated
             backend-pagination
             :total="total"
             :per-page="perPage"
             @page-change="onPageChange"

             backend-sorting
             default-sort-direction="desc"
             :default-sort="[sortField, sortOrder]"
             @sort="onSort"

             checkable
             :checked-rows.sync="checkedRows">
      <template slot-scope="props">
        <b-table-column :label="$t('financingSources.source')" field="source" sortable>
          {{ props.row.source__name }}
        </b-table-column>
        <b-table-column :label="$t('financingSources.percent')" width="140" numeric field="percent" sortable>
          {{ props.row.percent }}
        </b-table-column>
        <b-table-column width="150">
          <a @click="edit(props.row.id)">
            <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
            {{ $t('interface.edit') }}
          </a>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>{{ $t('interface.nothingFound') }}
              <a class="is-dashed" @click.prevent="resetFilters">{{ $t('interface.resetFiltersAndSearch') }}</a>.
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        checkedRows: []
      }
    },
    methods: {
      loadData() {
        this.checkedRows = []
        this.$store.dispatch('FinancingSource/getList', {
          params: {
            page: this.page,
            page_size: this.perPage,
            q: this.q,
            ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`
          },
          projectId: this.$route.params.projectId
        }).then(data => {
          this.total = data.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      resetFilters() {
        this.q = ''
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      edit(id) {
        this.$router.push({
          name: 'editFinancingSource',
          params: {projectId: this.$route.params.projectId, financingSourceId: id}
        })
      },
      removeSelected() {
        this.$dialog.confirm({
          title: this.$t('interface.dataDeleting'),
          message: this.$t('interface.dataDeletingMessage'),
          confirmText: this.$t('interface.dataDeleting'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          onConfirm: () => {
            this.checkedRows.map(row => {
              this.$store.dispatch('FinancingSource/remove', {
                projectId: this.$route.params.projectId,
                financingSourceId: row.id
              }).then(() => this.loadData())
            })
          }
        })
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('FinancingSource', ['list', 'loading'])
    }
  }
</script>